import React from "react";

export default class OptionalFeatureBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.warn("Optional Team Work feature disabled after a render error", error);
  }

  render() {
    if (this.state.failed) return null;
    return this.props.children;
  }
}
